import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CartWishlistContext = createContext();

export const useCartWishlist = () => {
  const context = useContext(CartWishlistContext);
  if (!context) {
    throw new Error('useCartWishlist must be used within CartWishlistProvider');
  }
  return context;
};

export const CartWishlistProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (user) {
      fetchCounts();
    }
  }, [user]);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('session_token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true,
        headers
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
      setCartCount(0);
      setWishlistCount(0);
    }
  };


  const fetchCounts = async () => {
    try {
      const token = localStorage.getItem('session_token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const [cartRes, wishlistRes] = await Promise.all([
        axios.get(`${API}/cart`, { withCredentials: true, headers }),
        axios.get(`${API}/wishlist/count`, { withCredentials: true, headers })
      ]);
      setCartCount(cartRes.data.reduce((sum, item) => sum + item.quantity, 0));
      setWishlistCount(wishlistRes.data.count || 0);
    } catch (error) {
      console.error('Failed to fetch counts:', error);
    }
  };

  const refreshCounts = () => {
    if (user) {
      fetchCounts();
    }
  };

  const updateCartCount = (delta) => {
    setCartCount(prev => Math.max(0, prev + delta));
  };

  const updateWishlistCount = (delta) => {
    setWishlistCount(prev => Math.max(0, prev + delta));
  };

  const value = {
    cartCount,
    wishlistCount,
    user,
    refreshCounts,
    updateCartCount,
    updateWishlistCount,
    setUser,
    setCartCount,      // Add this
    setWishlistCount,
    checkAuth
  };

  return (
    <CartWishlistContext.Provider value={value}>
      {children}
    </CartWishlistContext.Provider>
  );
};
